import { render, staticRenderFns } from "./singleSvg2.vue?vue&type=template&id=50781c6b&scoped=true&"
import script from "./singleSvg2.vue?vue&type=script&lang=js&"
export * from "./singleSvg2.vue?vue&type=script&lang=js&"
import style0 from "./singleSvg2.vue?vue&type=style&index=0&id=50781c6b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50781c6b",
  null
  
)

export default component.exports